import React from 'react';
export function Testimonials() {
  return <section className="py-[60px] px-5 bg-brand-dark2" data-id="element-317">
      <div className="max-w-[860px] mx-auto" data-id="element-318">
        <h2 className="text-[clamp(22px,4vw,36px)] font-black text-white mb-3 text-center" data-id="element-319">
          Lo Que Dicen los Trabajadores
        </h2>
        <p className="text-base text-brand-gray text-center mb-10 max-w-[600px] mx-auto" data-id="element-320">
          Resultados reales de personas como tú
        </p>

        <div className="grid grid-cols-[repeat(auto-fit,minmax(280px,1fr))] gap-5 max-w-[860px] mx-auto" data-id="element-321">
          <div className="bg-brand-dark3 border border-brand-border rounded-2xl p-6 transition-colors duration-300 hover:border-brand-yellow/30" data-id="element-322">
            <div className="text-brand-yellow text-sm mb-3" data-id="element-323">⭐⭐⭐⭐⭐</div>
            <p className="text-sm text-[#cdd9e5] leading-[1.6] italic mb-4" data-id="element-324">
              "En la primera semana cancelé $71 al mes en suscripciones que ni
              sabía que tenía. En el primer mes negocié $240 en late fees. Este
              sistema funciona."
            </p>
            <div className="text-[13px] font-bold text-brand-gray" data-id="element-325">
              — Diego R. · Warehouse · Dallas, TX
            </div>
          </div>

          <div className="bg-brand-dark3 border border-brand-border rounded-2xl p-6 transition-colors duration-300 hover:border-brand-yellow/30" data-id="element-326">
            <div className="text-brand-yellow text-sm mb-3" data-id="element-327">⭐⭐⭐⭐⭐</div>
            <p className="text-sm text-[#cdd9e5] leading-[1.6] italic mb-4" data-id="element-328">
              "No me dice 'gasta menos en café.' Me dice exactamente qué pagar
              primero cuando no alcanza. Eso es lo que necesitaba."
            </p>
            <div className="text-[13px] font-bold text-brand-gray" data-id="element-329">
              — Ramón V. · Técnico HVAC · Miami, FL
            </div>
          </div>

          <div className="bg-brand-dark3 border border-brand-border rounded-2xl p-6 transition-colors duration-300 hover:border-brand-yellow/30" data-id="element-330">
            <div className="text-brand-yellow text-sm mb-3" data-id="element-331">⭐⭐⭐⭐⭐</div>
            <p className="text-sm text-[#cdd9e5] leading-[1.6] italic mb-4" data-id="element-332">
              "Usé el Script #2 con mi landlord y me dio 2 semanas más sin
              problema. Nunca había podido tener esa conversación antes."
            </p>
            <div className="text-[13px] font-bold text-brand-gray" data-id="element-333">
              — José M. · Delivery · Chicago, IL
            </div>
          </div>

          <div className="bg-brand-dark3 border border-brand-border rounded-2xl p-6 transition-colors duration-300 hover:border-brand-yellow/30" data-id="element-334">
            <div className="text-brand-yellow text-sm mb-3" data-id="element-335">⭐⭐⭐⭐⭐</div>
            <p className="text-sm text-[#cdd9e5] leading-[1.6] italic mb-4" data-id="element-336">
              "Mi esposa y yo llevábamos meses sin hablar de dinero porque
              terminaba en pelea. El capítulo 9 nos cambió todo."
            </p>
            <div className="text-[13px] font-bold text-brand-gray" data-id="element-337">
              — Javier A. · Construcción · Phoenix, AZ
            </div>
          </div>

          <div className="bg-brand-dark3 border border-brand-border rounded-2xl p-6 transition-colors duration-300 hover:border-brand-yellow/30" data-id="element-338">
            <div className="text-brand-yellow text-sm mb-3" data-id="element-339">⭐⭐⭐⭐⭐</div>
            <p className="text-sm text-[#cdd9e5] leading-[1.6] italic mb-4" data-id="element-340">
              "Soy 1099. Nunca guardé para taxes. Apliqué el capítulo 13. Este
              año no voy a tener sorpresas en abril."
            </p>
            <div className="text-[13px] font-bold text-brand-gray" data-id="element-341">
              — Roberto S. · Instalador · Phoenix, AZ
            </div>
          </div>

          <div className="bg-brand-dark3 border border-brand-border rounded-2xl p-6 transition-colors duration-300 hover:border-brand-yellow/30" data-id="element-342">
            <div className="text-brand-yellow text-sm mb-3" data-id="element-343">⭐⭐⭐⭐⭐</div>
            <p className="text-sm text-[#cdd9e5] leading-[1.6] italic mb-4" data-id="element-344">
              "Cambiando de Western Union a Remitly ahorré $336 al año. Solo eso
              ya pagó el libro más de 50 veces."
            </p>
            <div className="text-[13px] font-bold text-brand-gray" data-id="element-345">
              — Carlos G. · Warehouse · Dallas, TX
            </div>
          </div>
        </div>
      </div>
    </section>;
}